/* eslint-disable import/no-default-export */
import ReactDOM from 'react-dom';
import { UIDProvider } from 'dibs-uid';
export default function makeOfferLauncher(options = {}) {
    const modalContainer = document.createElement('div');
    const {
        currency,
        itemId,
        environment,
        quantitySelected,
        shouldNotSendOfferMessage,
        launchOrigin,
        shouldLaunchContactDealer,
    } = options;
    return import(
        /* webpackChunkName: "makeOfferModal" */
        '../src/MakeOfferModal/makeOfferAsyncImports'
    ).then(mod => {
        const { components, helpers } = mod;

        const { MakeOfferModal, IntlProvider } = components;
        const { serverVars } = helpers;

        ReactDOM.render(
            <IntlProvider
                locale={serverVars.get('localeDataKey') || 'en'}
                messages={serverVars.get('messages')}
            >
                <UIDProvider prefix="offerModal">
                    <MakeOfferModal
                        launchOrigin={launchOrigin}
                        environment={environment}
                        itemId={itemId}
                        pageCurrency={currency}
                        quantitySelected={quantitySelected}
                        shouldNotSendOfferMessage={shouldNotSendOfferMessage}
                        shouldLaunchContactDealer={shouldLaunchContactDealer}
                    />
                </UIDProvider>
            </IntlProvider>,
            modalContainer
        );
    });
}
